import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { toggleSlidingMenu } from "../../../../../actions/toggleSlidingMenu";
import { Table } from "semantic-ui-react";
import WrapTextWithPopup from "../../../../../components/shared/WrapTextWithPopup";
import CircularButton from "../../../../../components/shared/circularbutton/CircularButton";
import QuickView from "../../../../../components/shared/quickview/QuickView";
import PortQuickView from "../../../../../components/shared/quickview/extensions/PortQuickView";
import { Port } from "../../../ports/types";

const PortItem = ({ port }: { port: Port }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onModify = useCallback(() => {
    dispatch(toggleSlidingMenu("modify", "Port", port));
  }, [dispatch, port]);

  return (
    <Table.Row>
      <Table.Cell title={port.name}>
        <PortQuickView port={port} />
      </Table.Cell>
      <Table.Cell title={port.gateway_ip}>
        <WrapTextWithPopup
          data={(port?.fixed_ips || [])
            .reduce((acc, item) => (acc += item.ip_address + " ,"), "")
            .slice(0, -2)}
          trimSize={12}
        />
      </Table.Cell>
      <Table.Cell>
        {port?.device_type ? (
          <QuickView>
            <QuickView.Trigger>
              {port.device_type + ":" + port.device_id}
            </QuickView.Trigger>
            <QuickView.Content>
              <QuickView.Item>{`Device ID: ${port.device_id}`}</QuickView.Item>
              <QuickView.Copy copy={port.device_id as string}>
                Copy Device ID
              </QuickView.Copy>
            </QuickView.Content>
          </QuickView>
        ) : (
          <span className="italic">- None -</span>
        )}
      </Table.Cell>
      <Table.Cell>
        <div className="flex vcenter">
          <CircularButton
            onClick={onModify}
            className={`button button--circular margin-right-half `}
            icon="edit"
            popupContent={t(`ports.actions.modify`)}
          />
        </div>
      </Table.Cell>
    </Table.Row>
  );
};

export default PortItem;
